/*
 * The Private License
 *
 * Copyright (c) 2023 Mahon Media LLC.
 */

import React from "react";
import ReactDOM from "react-dom";
import {BrowserRouter as Router} from "react-router-dom";
import App from "./App";
import {AuthProvider} from "./contexts/AuthContext";
import {NotificationProvider} from "./contexts/NotificationContext";
import {CustomersProvider} from "./contexts/CustomersContext";

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <CustomersProvider>
        <AuthProvider>
          <NotificationProvider>
            <App/>
          </NotificationProvider>
        </AuthProvider>
      </CustomersProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);
